import { Observable, catchError, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { GetDashboardDataResponse } from '@navstation-portal/reporting/data-model/crew-dashboard';
import { ApiErrorMapper, BASE_API_URL } from '@navstation-portal/shared/util/api';

@Injectable({
  providedIn: 'root',
})
export class CrewDashboardService {
  private http = inject(HttpClient);
  private readonly baseUrl = inject(BASE_API_URL);
  private apiError = inject(ApiErrorMapper).forFeature('CrewDashboard');

  getDashboardData(vesselId: string): Observable<GetDashboardDataResponse> {
    if (!vesselId) {
      const errorMessage = 'No vessel ID provided for fetching crew dashboard data.';
      this.apiError.logger.error(errorMessage);
      return throwError(() => new Error(errorMessage));
    }
    const url = `${this.baseUrl}/${vesselId}/dashboardData`;

    return this.http
      .get<GetDashboardDataResponse>(url)
      .pipe(catchError(this.apiError.toApiError('getting crew dashboard data')));
  }
}
